import type {
  SearchFilters,
  SearchMultiSelectFilters,
  SearchMultiSelectFilterType,
  SearchSelectFilters,
  SearchSelectFilterType,
  SelectedMultiOptionValues,
  SelectedOptionValue,
} from '@/scopes/search/search/infrastructure/api/types';
import type { FilterOption } from '@/scopes/search/types';

export const getMultiSelectFilterSelectedOption = <K extends SearchMultiSelectFilterType>(
  filtersData: Partial<SearchMultiSelectFilters>,
  filterType: SearchMultiSelectFilterType,
  filterSelectedValues: SelectedMultiOptionValues<SearchFilters[K]>
): FilterOption<string>[] => {
  const filter = filtersData[filterType];

  if (!filter) return [];

  const { options } = filter;

  return options.reduce<FilterOption<string>[]>(
    (acc, option) => (!filterSelectedValues.includes(option.value) ? acc : [...acc, option]),
    []
  );
};

export const getSelectFilterSelectedOption = <K extends SearchSelectFilterType>(
  filtersData: Partial<SearchSelectFilters>,
  filterType: SearchSelectFilterType,
  filterSelectedValue: SelectedOptionValue<SearchFilters[K]> | null
): FilterOption<string> | null => {
  const filter = filtersData[filterType];

  if (!filter) return null;

  const { options } = filter;

  if (!filterSelectedValue) return null;

  return options.find((option) => filterSelectedValue === option.value) || null;
};
